<template>
  <h4 class="small-heading">
    <slot></slot>
  </h4>
</template>

<script>
export default {
  name: 'SmallHeading',
  props: {
    text: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../scss/boilerplate';

.small-heading {
  padding: 1rem;
  margin: 0px;
  text-transform: uppercase;
  font-weight: $font-weight-bold;
  letter-spacing: 4px;
}
</style>


// WEBPACK FOOTER //
// SmallHeading.vue?66f5e57c